import { AddCircle } from "@mui/icons-material";
import { CardHeader, Icon, IconButton, Grid } from "@mui/material";
import { OrderService } from "app/services/order-service";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from 'app/components/Alert';
import { AlertService } from "app/services/alertService"
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import moment from "moment";
import LoadingModelComponent from "app/components/LoadingModelComponent";
import useAuth from 'app/hooks/useAuth';


const ListOrder = () => {

    // function getClientName(params) {

    //     return `${params.row.client.clientName} `;
    // }
    // function getWarehouse(params) {


    //     return `${params.row.subWarehouse.warehouse.warehouseName} `;
    // }
    // function getOrderType(params) {


    //     return `${params.row.orderType.description}`;
    // }
    const columns = [

        { field: 'id', headerName: 'Id', width: 130, hide: true },
        { field: 'orderNo', headerName: 'OutWard Code', width: 130, flex: 1 },
        {
            field: 'createdDate', headerName: 'OutWard Date', width: 150, flex: 1, valueFormatter: params => moment(params?.value).format("DD/MMM/yyyy hh:mm")
        },
        { field: 'clientName', headerName: 'Client Name', width: 130, flex: 1 },//, valueGetter: getClientName },
        { field: 'warehouseCode', headerName: 'Warehouse Name', width: 130, flex: 1 }, //, width: 130, valueGetter: getWarehouse },

        { field: 'orderStatusTypeDescription', headerName: 'Outward Status', width: 230, flex: 1 },
        // { field: 'description', headerName: 'Order Type', width: 150, valueGetter: getOrderType },

        {
            field: 'action',
            headerName: 'Action',
            sortable: false, width: 130,
            renderCell: (params) => {

                return <Grid>
                    {/* {params?.row.orderStatusTypeDescription === 'allocated' ? <IconButton title="Review and Approve Order" onClick={() => toReviewAndApprove(params.row)}  >
                        <Icon color="action" >done</Icon>
                    </IconButton> : null} */}

                    <IconButton title="Edit Order" onClick={() => toEditOrCreate(params.row)}  >
                        <Icon color="action" >edit</Icon>


                    </IconButton>
                    <IconButton title="Delete order" onClick={() => deleteById(params.row)}>
                        <Icon color="action" >delete</Icon>

                    </IconButton>
                </Grid>
            },
        },

    ];
    const [page, setPage] = useState(25);
    const toEditOrCreate = (data) => {

        navigate('/outward/Order/create', { state: { data } });
    }
    const toReviewAndApprove = (data) => {
        navigate('/outward/Order/approve', { state: { data } });
    }
    const deleteById = (index) => {

        if (index.orderStatusTypeDescription === "review and accept") {
            AlertService.error('order accepted, we cant delete this outward.', { keepAfterRouteChange: true });
            return;
        }
        OrderService.delete(index.id)
            .then((res) => { loadOrder() })
            .catch((err) => { console.log(err.message); });

    }
    const navigate = useNavigate();
    const [OrderList, setOrderList] = useState([]);
    const [IsLoaded, setIsLoaded] = useState(false);
    const { user } = useAuth();
    useEffect(() => loadOrder(), []
    );





    const loadOrder = () => {
        setIsLoaded(true);
        OrderService
            .getAll()
            .then(order => {

                if (order !== null) {
                    setOrderList(order.filter(res => res.clientId === user?.clientId));

                }
                setIsLoaded(false);
                // else { AlertService.error("There is no Data for Login User", { keepAfterRouteChange: true }); }
            })
            .catch((err) => {

                console.log(err.message);
                setIsLoaded(false);
                AlertService.error(err.message, { keepAfterRouteChange: true });
            });
    }
    return (
        <div style={{ height: '80%', width: '100%' }}>
            <LoadingModelComponent isLoading={IsLoaded} />
            <Alert />

            <Grid><a href='/assets/images/wms_template/outward/outwardV1_Template.csv' download>Click to download Outward Template</a>
                <CardHeader title="Outward Notes" action={
                    <IconButton aria-label="settings" onClick={() => toEditOrCreate()}><AddCircle sx={{ fontSize: 30 }} align="right" /></IconButton>
                } >
                </CardHeader>
            </Grid>
            <DataGrid
                rows={OrderList}
                density="compact"
                columns={columns}
                disableMultipleSelection={true}

                pageSize={page}
                // rowsPerPage={rowsPerPage}
                // onPageChange={handleChangePage}
                // checkboxSelection

                // onPageSizeChange={(newPageSize) => setPage(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                //rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
                pagination
                components={{ Toolbar: GridToolbar }}
            />
        </div>

    );
}



export default ListOrder